/* eslint-disable no-underscore-dangle */
import { postGenericMessage } from '../messages.js';
export * from './app.js';
export * from './routing.js';
export * from './store.js';
export * from './analytics.js';
export * from './messages.js';
export * from './useIframeDetection.js';
export function getConfig(key) {
    const isBrowser = () => typeof window !== 'undefined';
    let config;
    if (!isBrowser()) {
        config = process.env[`NUXT_PUBLIC_${key}`] || process.env[`NUXT_${key}`];
    }
    else {
        // Avec Nuxt 4, __NUXT__ est supprimé après l'hydratation. Pour garder les valeurs accessibles, on les stocke dans window.env
        if (window.__NUXT__?.config?.public && !window.env)
            window.env = window.__NUXT__.config.public;
        config =
            window.parent?.parent?.env?.[key] ||
                window.parent?.env?.[key] ||
                window.env?.[key] ||
                window.env?.[`VITE_${key}`] ||
                window.__NUXT__?.config?.public?.[key];
    }
    if (key === 'APP_CONTEXT' && config === 'umg-us')
        config = 'countrymalt';
    return config;
}
export function emitMessageToEventBus({ message, data = {} }) {
    postGenericMessage({
        message,
        data,
    }, true);
}
/**
 * @deprecated for B2B MonoRepo => use emitMessageToEventBus
 */
export function emitMessageToParent({ message, data = {} }) {
    postGenericMessage({
        message,
        data,
    });
}
/**
 * @deprecated for B2B MonoRepo => use emitMessageToEventBus
 */
export function emitMessageToParentInSameIframe({ message, data = {} }) {
    postGenericMessage({
        message,
        data,
    }, true);
}
export function getAppContext() {
    return {
        appBusinessType: getConfig('APP_CONTEXT'),
        appFrontType: getConfig('CONTEXT_APP'),
        isFrontAgri: getConfig('CONTEXT_APP') === 'agri',
        isFrontTech: getConfig('CONTEXT_APP') === 'tech',
    };
}
//# sourceMappingURL=index.js.map